const Constants = {
	FEATURE_FLAGS_KEY: 'Launch__Darkly__Client_ID',
	FEATURE_FLAGS_URL: 'LaunchDarkly__ExternalUrl',
} as const;

export default Constants;
